( function( $ ){

    let requesting_post = false;

    // Request article on scroll
    $( document ).on( 'scroll', ( e ) => {

        if( requesting_post ){
            return;
        }

        let is_sponsored    = $( 'article.post-current' ).attr( 'data-sponsored' );
        if( 'true' == is_sponsored ){
            return;
        }
        
        // Check if next article was already requested
        let $current            = $( 'article.post-current' );
        if( $current.next( 'article.single-post' ).length ){
            return;
        }

        let scrollBottom        = $( window ).scrollTop() + $( window ).height();
        let articleBottom       = $current.position().top + $current.height(); 
        
        if( scrollBottom >= articleBottom - 200 ){
            if( typeof properInfNewPage !== 'undefined' ){
                properInfNewPage();
            }
            requesting_post = true;
            get_next_article();
        }

    });

    // Update window history
    $( document ).on( 'scroll', ( e ) => {
        let $current            = $( 'article.post-current' );
        let articleTop          = $current.position().top;
        let articleBottom       = articleTop + $current.height();
        let scrollTop           = $( window ).scrollTop();
        if( scrollTop > articleBottom ){
            let $next   = $current.next( 'article.single-post' );
            if( $next.length ){
                switch_current_article( $next );
            }
        }
        if( scrollTop < articleTop ){
            let $last   = $current.prev( 'article.single-post' );
            if( $last.length ){
                switch_current_article( $last );
            }
        }
    });

    // Switch the current article
    function switch_current_article( $switch_to ){
        let $current            = $( 'article.post-current' );
        let current_title       = $current.attr( 'data-posttitle' );
        let current_permalink   = $current.attr( 'data-postpermalink' );
        window.history.replaceState({
            path: current_permalink,
            scrollTop: $current.position().top
        }, current_title, current_permalink );

        $current.removeClass( 'post-current' );
        $switch_to.addClass( 'post-current' );
        let title       = $switch_to.attr( 'data-posttitle' );
        let permalink   = $switch_to.attr( 'data-postpermalink' );
        window.history.pushState( { scrollTop: 0}, title, permalink );
        $( 'link[rel="canonical"]' ).attr( 'href', permalink );
    }

    // Get next lazy article
    function get_next_article(){
        let offset          = $( 'article.single-post' ).length - 1;
        let original_id     = $( 'article.single-post' ).first().attr( 'data-postid' );
        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lazyload_next_article',
                offset,
                original_id
            },
            success : (res) => {
                let content     = res.content;
                let $current    = $( '.post-current' );
                $current.after( content );
                requesting_post = false;
                if( typeof FB != 'undefined' ){
                    FB.XFBML.parse();
                }
                if( typeof properBuildSlots !== 'undefined' ){
                    properBuildSlots();
                }
                ThemeJS.Tracking.new_ads();
            },
            error : (res) => {
                console.log( 'No More Posts to Load.' );
            }
        })
    }

    // Capture back button
    window.onpopstate = function( e ){
        e.preventDefault();
        let $target_article = $( '.single-post[data-postpermalink="'+ document.location.href +'"]' );
        $( 'html, body' ).animate({
            scrollTop: $target_article.offset().top - 75
        });
    }

    // Fix GAM ad slot size
    let districtTimer;
    if( $( window ).width() < 767 ) {

        districtTimer = setInterval( districtAds, 500 );
        
        if( $( '#div-gpt-ad-1602854729929-0 iframe' ).attr( 'width' ) == 300) {
            $('#div-gpt-ad-1602854729929-0').css({'width':'300px','height':'270px','margin':'0 auto'});
            $('#div-gpt-ad-1602854729929-0 iframe').css({'min-width':'100%','width':'300px','height':'250px'});
        } else {
            $('#div-gpt-ad-1602854729929-0 iframe').css({'height': 'auto'});
            $('#div-gpt-ad-1602854729929-0 iframe').contents().find('img').css({'width':'100%', 'height':'100%'});
        }
        
        $('#div-gpt-ad-1602854729929-0').show();
        
    }
        
    let districtCounter = 0;
    function districtAds() {
        
        if( $( '#div-gpt-ad-1602854729929-0 iframe' ).attr( 'width' ) != 300 && $(window).width() < 767) {
        
            $('#div-gpt-ad-1602854729929-0 iframe').css({'height': '200px', 'max-width': '100%'});
            $('#div-gpt-ad-1602854729929-0 iframe').contents().find('img').css({'width':'100%', 'height':'100%'});
        
            districtCounter++;
        
            if(districtCounter >= 30) {
                clearInterval(districtTimer);
            }

        }

    }

})( jQuery );